<template>
    <div>
        <!-- <linkbutton toplabel="Populate and Fill" @click="Start()" class="alertlink"/> -->
    <!-- ACCT NOTE MODAL -->
      <actionmodalwide ref="mymodal"> 
        <template v-slot:body>
            <form ref="mydiv">
                <div class="rightjustified noprint">
                    <input id="printbutton" class="margin10 " type="button" @click="doprint()" value="Print" />
                 </div>
                    <div class="docclass">
                        <div v-for="item in document.items" :key="item.id" :value="item.id" :class="divclass(item)">
                             <!-- yesno start-->
                             <label v-if="item.enter=='ynstart'">YES</label>
                            <input v-if="item.enter=='ynstart'" type="checkbox"  class="checkclass"/>
                            <label v-if="item.enter=='ynstart'"for="">NO</label>
                            <input  v-if="item.enter=='ynstart'" type="checkbox" class="checkclass"/>

                            <!-- checkstart -->
                            <input v-if="item.enter=='checkstart'" type="checkbox"  class="checkclass"/>

                            <label  v-if="item.text!=null" >{{ item.text }}</label>
                            
                            <!-- input -->
                            <input v-if="item.enter=='wide'" class="inputclass"/>
                            <input v-if="item.enter=='narrow'" class="inputclassnarrow"/>
                            <input v-if="item.enter=='extrawide'" class="inputclassextrawide"/>
                           
                            <!-- yesno -->
                            <label v-if="item.enter=='yn'">YES</label>
                            <input v-if="item.enter=='yn'" type="checkbox"  class="checkclass"/>
                            <label v-if="item.enter=='yn'"for="">NO</label>
                            <input  v-if="item.enter=='yn'" type="checkbox" class="checkclass"/>
                            
                            
                            <!-- <br v-if="item.text==null"> -->
                             <div v-if="item.table" >
                                <div class="horizFlex">
                                    <div v-for="header in item.headerlist" :key="header.id" :value="header.id" :class="divclass_table(header)">
                                        <label  v-if="header.text!=null" >{{ header.text }}</label>
                                    </div>
                                </div>
                                
                                <div v-for="row in item.rowlist" :key="row.id" :value="row.id" class="">
                                    <div class="horizFlex">
                                        <div v-for="rowitem in row.rowitemlist" :key="rowitem.id" :value="rowitem.id" :class="divclass_table(rowitem)">
                                            <div v-html="rowitem.text"  v-if="rowitem.text!=null" class="htmllabel"></div>
                                        </div>
                                    </div>
                                    
                                    
                                </div>
                             </div>
                        </div>
                    </div>
                    


                    <div>
                        <smallbutton id="closebutton"  @click="$refs.mymodal.closeModal()" toplabel="Close"/>
                    </div>
             
               
               
          </form>
        </template>
      </actionmodalwide>
    </div>
</template>
    
<script>
    import actionmodalwide from '../controls/actionmodalwide.vue'
import linkbutton from '../controls/linkbutton.vue'
import smallbutton from '../controls/button.vue'
import { activated } from 'vue-global-events'

    export default {
        name:'popandfill',
        components:{
          actionmodalwide,
          linkbutton,
          smallbutton
        },
        props:{
            
            
        },
        mixins:[],
        data(){
            return{
                document:{
                    items:[]
                }
                 /* document:{
                    items:[
                        {
                            id:1,
                            text:'Affordable CDL Training School',
                            size:'xx-large',
                            alignment:'center',
                            bold:false

                        },
                        {
                            id:2,
                            text:'532A New London Rd',
                            size:'xx-large',
                            alignment:'center',
                            bold:false

                        },
                        {
                            id:6,
                            text:'Admission Requirements:',
                            size:'x-large',
                            alignment:'left',
                            bold:true,
                            margintoplarge:true

                        },
                        {
                            id:7,
                            text:'Affordable CDL Training School requires that all students at the time of enrollment be at least 18 yrs. of',
                            size:'medium',
                            alignment:'left',
                            bold:false

                        },
                        {
                            id:7,
                            text:'age. The student, must  have a current and valid State of Ct. Driver license. It is the student ',
                            size:'medium',
                            alignment:'left',
                            bold:false

                        },
                        {
                            id:7,
                            text:'responsibility to confirm eligibility with The State of Ct. Motor Vehicle Dept.  Prior to enrollment. ',
                            size:'medium',
                            alignment:'left',
                            bold:false

                        },
                       
                        {
                            id:8,
                            text:'Personal Information:',
                            size:'x-large',
                            alignment:'left',
                            bold:true,
                            margintop:true

                        },
                        {
                            id:8,
                            text:'Name: Joe Schmortz',
                            size:'medium',
                            alignment:'left',
                            bold:true,
                            margintop:true

                        },
                      
                        {
                            id:8,
                            text:'Driving Record:',
                            size:'x-large',
                            alignment:'left',
                            bold:true,
                            margintop:true

                        },
                        {
                            id:8,
                            text:'Ct. Driver License Number: ',
                            size:'medium',
                            alignment:'left',
                            bold:true,
                            enter:'wide',
                            margintop:true
                            

                        },
                        {
                            id:8,
                            text:'Have you ever been convicted of a criminal offence? ',
                            size:'medium',
                            alignment:'left',
                            bold:true,
                            enter:'yn'
                            

                        },
                        {
                            id:9,
                            table:true,
                            headerlist:[
                                {
                                    id:1,
                                    text:'Course',
                                    size:'small',
                                    alignment:'left',
                                    bold:true,
                                    width:'width-large',
                                    margintop:true
                                },
                                {
                                    id:1,
                                    text:'Tuition Cost',
                                    size:'small',
                                    alignment:'left',
                                    bold:true,
                                    width:'width-small',
                                    margintop:true
                                },
                                {
                                    id:1,
                                    text:'Book Fees (Textbook-refundable)',
                                    size:'small',
                                    alignment:'left',
                                    bold:true,
                                    width:'width-small',
                                    margintop:true
                                },
                                {
                                    id:1,
                                    text:'I-Class Hours',
                                    size:'small',
                                    alignment:'left',
                                    bold:true,
                                    width:'width-small',
                                    margintop:true
                                },
                                {
                                    id:1,
                                    text:'Lab Hours',
                                    size:'small',
                                    alignment:'left',
                                    bold:true,
                                    width:'width-small',
                                    margintop:true
                                },
                                {
                                    id:1,
                                    text:'In-Class Time/Schedule',
                                    size:'small',
                                    alignment:'left',
                                    bold:true,
                                    width:'width-large',
                                    margintop:true
                                }
                            ],
                            rowlist:[
                                {
                                    rowitemlist:[
                                        {
                                            id:1,
                                            text:'CDL Tractor Trailer Training Class A Evening (Total Program hours 140 Min.)',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-large'
                                        },
                                        {
                                            id:1,
                                            text:'$4,600.00*',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-small'
                                        },
                                        {
                                            id:1,
                                            text:'$55.00',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-small'
                                        },
                                        {
                                            id:1,
                                            text:'In-Class 40 hr',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-small'
                                        },
                                        {
                                            id:1,
                                            text:'100 hr',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-small'
                                        },
                                        {
                                            id:1,
                                            text:'<b>Evening Schedule</b><br>(In Class/Lab Evening Schedule) 5:30-8:30 PM M/W/TH 8:30 AM-5PM Sat/Sun<br><b>Day Schedule</b><br>M-F 8:00am-4:30pm <br><b>By Appointment</b>',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-large'
                                        }
                                    ]
                                },
                                {
                                    rowitemlist:[
                                        {
                                            id:1,
                                            text:'CDL Tractor Trailer Training Class A Evening (Total Program hours 140 Min.)',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-large'
                                        },
                                        {
                                            id:1,
                                            text:'$4,600.00*',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-small'
                                        },
                                        {
                                            id:1,
                                            text:'$55.00',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-small'
                                        },
                                        {
                                            id:1,
                                            text:'In-Class 40 hr',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-small'
                                        },
                                        {
                                            id:1,
                                            text:'100 hr',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-small'
                                        },
                                        {
                                            id:1,
                                            text:'<b>Evening Schedule</b><br>(In Class/Lab Evening Schedule) 5:30-8:30 PM M/W/TH 8:30 AM-5PM Sat/Sun<br><b>Day Schedule</b><br>M-F 8:00am-4:30pm <br><b>By Appointment</b>',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-large'
                                        }
                                    ]
                                }
                                    
                                    
                                
                            ]
                        },
                        {
                            id:8,
                            text:'I (initial) _______ understand by signing my name that I acknowledge I have read and understand this',
                            size:'small',
                            alignment:'left',
                            bold:false,
                            margintop:true

                        },
                  
                        {
                            id:8,
                            text:'Student Signature: ______________________________________   Date: _________________',
                            size:'small',
                            alignment:'left',
                            bold:false,
                            margintop:true

                        },

                    ]
                 } */
                    
            }
        },
        computed:{
            
          
        },
        methods:{
            doprint(){
                var mythis = this

                document.getElementById('printbutton').style.visibility = 'hidden';
                document.getElementById('closebutton').style.visibility = 'hidden';

                

                window.print();
                document.getElementById('printbutton').style.visibility = 'visible';
                document.getElementById('closebutton').style.visibility = 'visible';
            },
            
            Start(doc){
                this.document=doc
                this.$refs.mymodal.openModal()
            },
            
            divclass(item){
                var cls=''
                
                cls=cls + ' ' + item.alignment
                cls=cls + ' ' + item.size
                if(item.bold){cls=cls + ' bold'}
                if(item.margintoplarge){cls = cls + ' itemmargintoplarge'}
                else if(item.margintop){cls = cls + ' itemmargintop'}
                else{cls = cls + ' item'}
                if(item.width!=undefined){
                    cls = cls + ' ' + item.width
                }
                return cls
            },
            divclass_table(item){
                var cls='bordered'
                
                cls=cls + ' ' + item.alignment
                cls=cls + ' ' + item.size
                if(item.bold){cls=cls + ' bold'}
                if(item.margintoplarge){cls = cls + ' tableitemmargintoplarge'}
                else if(item.margintop){cls = cls + ' tableitemmargintop'}
                else{cls = cls + ' tableitem'}
                if(item.width!=undefined){
                    cls = cls + ' ' + item.width
                }
                return cls
            }
        },
        mounted(){
    
          
        },
        
    }
</script>
    
<style scoped>
    .itemmargintop{
        margin-top:20px;
        padding:0px;
    }
    .itemmargintoplarge{
        margin-top:40px;
        padding:0px;
    }
    .docclass{
        padding:0px;
        
        /* height:72vh; */
    }
    .inputclass{
        margin-left:5px;
    }
    .inputclassnarrow{
        margin-left:5px;
        width:50px;
    }
    .inputclassextrawide{
        margin-left:5px;
        width:500px;
    }
    .item{
        margin-top:5px;
        margin-bottom:5px;
        padding:0px;
    }
    .bold{
        font-weight: bold;
    }
    .small{
        font-size:small;
    }
    .medium{
        font-size:medium
    }
    .large{
        font-size:large
    }
    .x-large{
        font-size:x-large
    }
    .xx-large{
        font-size:xx-large
    }
    .center{
        text-align: center;
    }
    .left{
        text-align: left;
    }
    .bordered{
        border:1px solid gray;
        border-radius:0px;

    }
    .horizFlex{
    display:flex;
    flex-direction: row;

  }
  .tableitem{
    padding:5px;
    
  }
  .tableitemmargintop{
        margin-top:20px;
        padding:5px;
    }
    .tableitemmargintoplarge{
        margin-top:40px;
        padding:5px;
    }
  .width-small{
    width:100px;
  }
  .width-medium{
    width:100px;
  }
  .width-large{
    width:200px;
  }
  .htmllabel{
    white-space: pre-wrap;
  }
</style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    